import moment from "moment";
//eslint-disable-next-line
import momentTimezone from "moment-timezone"; // Do not remove, required for timezone calculation in moment.

export const initializeValues = ({ featureType, selectedPhotoPoint }) => {
  let coordinates =
    selectedPhotoPoint?.LOCATION?.latitude &&
    selectedPhotoPoint?.LOCATION?.longitude
      ? selectedPhotoPoint.LOCATION.latitude +
        ", " +
        selectedPhotoPoint.LOCATION.longitude
      : "Coordinates: N/A";
  let structureName =
    selectedPhotoPoint?.STRUCTURE_NAME || "Structure Name: N/A";
  let featureValue = featureType || "Feature Type: N/A";
  let accountCode = selectedPhotoPoint?.ACCOUNTCODE || "Account Code: N/A";
  return {
    accountCode,
    coordinates,
    featureValue,
    structureName,
  };
};

export const getAspectRatio = (image) => {
  try {
    const maxPhotoWidth = 400;
    const maxPhotoHeight = 400;
    if (image.width > maxPhotoWidth) return maxPhotoWidth / image.width;
    if (image.height > maxPhotoHeight) {
      return maxPhotoHeight / image.height;
    }
  } catch {}
  return 1;
};

export const createCanvasCtx = (image) => {
  let ratio = getAspectRatio(image);

  let canvas = document.createElement("canvas");
  const canvasCopy = document.createElement("canvas");
  const copyContext = canvasCopy.getContext("2d");

  canvasCopy.width = image.width;
  canvasCopy.height = image.height;
  copyContext.drawImage(image, 0, 0);
  canvas.width = image.width * ratio;
  canvas.height = image.height * ratio;

  let ctx = canvas.getContext("2d");
  ctx.drawImage(
    canvasCopy,
    0,
    0,
    canvasCopy.width,
    canvasCopy.height,
    0,
    0,
    canvas.width,
    canvas.height
  );

  return {
    canvas,
    ctx,
  };
};

export const writeToCanvas = ({
  accountCode,
  address,
  canvas,
  coordinates,
  ctx,
  featureValue,
  structureName,
}) => {
  // Write text to the canvas.
  const fontSize = 12;
  ctx.font = fontSize + "px Arial";
  ctx.fillStyle = "white";
  ctx.strokeStyle = "black";
  ctx.lineWidth = 3;
  ctx.textAlign = "right";
  const momentTime = moment()
    .tz("America/Chicago")
    .format("MMMM Do YYYY, h:mm a");

  ctx.strokeText(momentTime, canvas.width - 5, canvas.height - fontSize * 6);
  ctx.fillText(momentTime, canvas.width - 5, canvas.height - fontSize * 6);
  ctx.strokeText(structureName, canvas.width - 5, canvas.height - fontSize * 5);
  ctx.fillText(structureName, canvas.width - 5, canvas.height - fontSize * 5);
  ctx.strokeText(featureValue, canvas.width - 5, canvas.height - fontSize * 4);
  ctx.fillText(featureValue, canvas.width - 5, canvas.height - fontSize * 4);
  ctx.strokeText(accountCode, canvas.width - 5, canvas.height - fontSize * 3);
  ctx.fillText(accountCode, canvas.width - 5, canvas.height - fontSize * 3);
  ctx.strokeText(coordinates, canvas.width - 5, canvas.height - fontSize * 2);
  ctx.fillText(coordinates, canvas.width - 5, canvas.height - fontSize * 2);
  ctx.strokeText(address, canvas.width - 5, canvas.height - fontSize);
  ctx.fillText(address, canvas.width - 5, canvas.height - fontSize);
  ctx.save();
};

export const getCanvasURL = (canvas) => {
  // return canvas.toDataURL();
  return new Promise(function (resolve) {
    canvas.toBlob(function (blob) {
      var url = URL.createObjectURL(blob);
      resolve(url);
    }, "image/jpeg");
  });
};
